import { useSnackbar } from 'notistack';
import React from 'react';

export const ToastContext = React.createContext(null);

const { Provider } = ToastContext;
export const ToastProvider = ({ ...props }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const showInfoMessage = (message, key) => {
        const snackOptions = { key: key ?? Date.now(), variant: "info", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showSuccessMessage = (message, key) => {
        const snackOptions = { key: key ?? Date.now(), variant: "success", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showWarningMessage = (message, key) => {
        const snackOptions = { key: key ?? Date.now(), variant: "warning", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showErrorMessage = (message, key) => {
        const snackOptions = { key: key ?? Date.now(), variant: "error", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showLoadingMessage = (message, key) => {
        const snackOptions = { key: key, variant: "info", persist: true };
        enqueueSnackbar(message, snackOptions);
    }

    const closeLoadingMessage = (key) => {
        closeSnackbar(key);
    }

    return (
        <Provider value={{
            showInfoMessage,
            showSuccessMessage,
            showWarningMessage,
            showErrorMessage,
            showLoadingMessage,
            closeLoadingMessage,
        }}>
            {props.children}
        </Provider>
    );
}